import { useAppSelector } from './store';

/**
 * Gets the project ID as specified in the terminal config.
 */
export default function useProject() {
  return useAppSelector(state => state.root.terminal.config?.project);
}
